const state = {
  dia: {},
  historico: {},
  acumulado: {},
  titulo: '',
  cnpj: ''
}

const mutations = {
  fillDataRelatorioDia (state, res) {
    state.dia = res.data
  },
  fillDataRelatorioHistorico (state, res) {
    state.historico = res.data
  },
  fillDataRelatorioAcumulado (state, res) {
    state.acumulado = res.data.grafico
    state.titulo = res.data.titulo
  },
  fillDataRelatorioHistoricoDias (state, res) {
    state.historico = res.data.grafico
    state.titulo = res.data.titulo
  }
}

const actions = {
  createRelatorioHistorico (context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/api/v1/sd202019/relatorios', data).then((res) => {
      context.commit('fillDataRelatorioHistorico', res)
      return res
    })
  },
  createRelatorioGeracaoSeteDias(context, data) {
    // console.log(data)
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/api/v1/sd202019/relatorios/setedias', data).then((res) => {
      context.commit('fillDataRelatorioHistoricoDias', res)
      console.log(res)
      return res
    })
  },
  createRelatorioAcumuladoDias (context, data) {
    let qs = require('querystring')
    data = qs.stringify(data)
    return window.axios.post('/api/v1/sd202019/relatorios/dias', data).then((res) => {
      context.commit('fillDataRelatorioAcumulado', res)
      return res
    })
  }
}

export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/Relatorios.js